import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ENERGY_RATINGS_DENMARK, ENERGY_RATINGS_PASSIVE, ENERGY_RATINGS_SCHEWIZ, ENERGY_RATINGS_UK, findRatingIdByEnergyValue } from 'src/app/utils/Constants';

interface EnergyRating {
  id: number;
  range: string;
  grade: string;
  color: string;
  minWidth: string;
  lowLimit: number;
  highLimit: number;
  isDarkText: boolean;
}
@Component({
  selector: 'app-window-energy-rating-details',
  templateUrl: './window-energy-rating-details.component.html',
  styleUrls: ['./window-energy-rating-details.component.scss'],
  standalone: false,
})
export class WindowEnergyRatingDetailsComponent implements OnInit {
  @Input() selCountry: any;
  @Input() result: any;
  selRatingId: number | null = null;
  energyValue = 0
  energyRatings: any = [];
  zonesRows = [
    { label: 'A', z1: '', z2: '', z3: '' },
    { label: 'B', z1: '', z2: '', z3: '' },
    { label: 'C', z1: '', z2: '', z3: '' },
    { label: 'D', z1: '', z2: '', z3: '' },
    { label: 'E', z1: '', z2: '', z3: '' },
    { label: 'F', z1: '', z2: '', z3: '' },
    { label: 'G', z1: '', z2: '', z3: '' }
  ];
  energyGrades = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.init();
  }

  init() {
    if (this.selCountry == 'Schweiz') {
      this.energyRatings = ENERGY_RATINGS_SCHEWIZ;
      this.energyValue = this.result.uweq;
    } else if (this.selCountry == 'Dänemark') {
      this.energyRatings = ENERGY_RATINGS_DENMARK;
      this.energyValue = this.result.eref;
    } else if (this.selCountry == 'Frankreich') {
      // this.energyRatings = this.ENERGY_RATINGS_UK;
      this.populateZones()
      this.energyValue = this.result.sw;
    } else if (this.selCountry == 'Großbritannien') {
      this.energyRatings = ENERGY_RATINGS_UK;
      this.energyValue = this.result.wer;
    } else if (this.selCountry == 'Other') {
      this.energyRatings = ENERGY_RATINGS_PASSIVE;
      this.energyValue = this.result.psiOpaque;
    }
    this.selRatingId = findRatingIdByEnergyValue(this.energyValue, this.energyRatings)?.id
  }

  populateZones() {
    // Populate Z1 column - add badge value to the corresponding label row
    this.zonesRows.forEach(row => {
      // For Z1: badgeZ1 = 'B' should populate in row with label 'B'
      if (row.label === this.result.badgeZ1) {
        row.z1 = this.result.badgeZ1;
      }

      if (row.label === this.result.badgeZ2) {
        row.z2 = this.result.badgeZ2;
      }

      if (row.label === this.result.badgeZ3) {
        row.z3 = this.result.badgeZ3;
      }
    });
  }
  // Helper method to get CSS class name from grade
  getRatingClass(grade: string): string {
    return grade.toLowerCase().replace('+', '-plus').replace(/\+/g, '-plus');
  }
  // Check if this rating is selected
  isSelected(ratingId: number): boolean {
    return this.selRatingId === ratingId;
  }

  close() {
    this.modalController.dismiss();
  }
}
